<template>
	<app-table :columns="paymentColumns" :data="payments" :searchable="true">
		<template v-slot:docDate="{ item }">
			{{ $filters.formatShortDate(item.docDate) }}
		</template>
		<template v-slot:paymentUnit="{ item }">
			{{ item.paymentUnit.description }}
		</template>
		<template v-slot:invoiceID="{ item }">
			<app-details-shortcut
				v-if="item.items"
				:route-name="RouteNames.InvoiceDetails"
				:identifier="item.items[0].invoice.id"
			/>
		</template>
		<template v-slot:invoiceDate="{ item }">
			<span v-if="item.items">{{ item.items[0].invoice.docDate }}</span>
		</template>
		<template v-slot:accManager="{ item }">
			{{ item.restaurant.accManager.name }} {{ item.restaurant.accManager.surname }}
		</template>
		<template v-slot:restaurant="{ item }">
			{{ restaurantName(item) }}
		</template>
		<template v-slot:amountCents="{ item }">
			{{ $filters.formatCurrency(item.amountCents / 100, item.restaurant.currency) }}
		</template>
	</app-table>
</template>

<script>
	import constants from '@/constants/finance';
	import AppTable from '@/components/app/AppTable';
	import AppDetailsShortcut from '@/components/app/AppDetailsShortcut';
	import RouteNames from '@/router/names';

	export default {
		name: 'PaymentTable',
		props: ['payments'],
		components: {
			AppDetailsShortcut,
			AppTable,
		},
		data: () => ({
			RouteNames,
			paymentColumns: constants.paymentColumns,
		}),
		methods: {
			restaurantName(item) {
				const restaurant = item.items ? item?.items[0].invoice.restaurant : item.restaurant;
				return restaurant?.restaurantName || 'N/A';
			},
		},
	};
</script>
